import { Observable } from 'rxjs/Observable'

import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Route, CanActivate, CanLoad, CanActivateChild } from '@angular/router'

import { AuthService } from './auth.service'

@Injectable()
export class AuthLoadGuard implements CanLoad {
  constructor ( public auth: AuthService ) { }

  canLoad ( route: Route ): Promise<boolean> {
    return new Promise(resolve => {
      this.auth.authenticate()
      .subscribe(user =>
        resolve(
          user && user.permissions && (
            route.data && route.data.permissions &&
            (console.log('load', user.permissions, route.data.permissions), true) &&
            [].concat(route.data.permissions).every(permission =>
              user.permissions[permission]
            )
          )
        )
      )
    })
  }
}

@Injectable()
export class AuthActivateGuard implements CanActivate {
  constructor ( public auth: AuthService ) { }

  canActivate ( next: ActivatedRouteSnapshot ): Observable<boolean> | boolean {
    return this.auth.authenticate()
      .map(user =>
        user && user.permissions && (
          next.data && next.data.permissions &&
            (console.log('activate', user.permissions, next.data.permissions), true) &&
            [].concat(next.data.permissions).every(permission =>
            user.permissions[permission]
          )
        )
      )
  }
}

@Injectable()
export class AuthActivateChildGuard implements CanActivateChild {
  constructor ( public auth: AuthService ) { }

  canActivateChild ( childRoute: ActivatedRouteSnapshot ): Observable<boolean> | boolean {
    return this.auth.authenticate()
      .map(user =>
        user && user.permissions && (
          childRoute.data && childRoute.data.permissions &&
            (console.log('activateChild', user.permissions, childRoute.data.permissions), true) &&
            [].concat(childRoute.data.permissions).every(permission =>
            user.permissions[permission]
          )
        )
      )
  }
}
